
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TextValue } from "../Components/Text.js";
import { useTranslation } from "react-i18next";
import { reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";

export function IKBLeitstelleReceiverPrivacyStatement() {
    const xs_1 = [createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: useTranslation()[0]("ikb.new_receiver_privacy_info"),
    }), reactElement("a", {
        className: join(" ", ["text-sm", "font-medium", "flex", "items-center"]),
        children: "https://www.ikb.at/fileadmin/user_upload/Dokumente/IKB_Allgemein/Datenschutzerklaerung.pdf",
        target: "_blank",
        href: "https://www.ikb.at/fileadmin/user_upload/Dokumente/IKB_Allgemein/Datenschutzerklaerung.pdf",
    })];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

